import moment from 'moment';

export const newGarageRow = () => ({ garageId: null, dates: [] });

const getProposedDates = (proposedChanges) =>
  proposedChanges
    .filter((proposedChange) => proposedChange.type === 'collection-time')
    .map(({ value }) => moment(value).format('YYYY-MM-DD'));

const getAvailabilityFromExistingProposedChanges = (garageInvites) => {
  const invitesToReview = garageInvites.filter(({ status }) => status === 'review');
  return invitesToReview.map(({ garageId, proposedChanges }) => ({
    garageId,
    dates: getProposedDates(proposedChanges),
  }));
};

const getDraftAvailabilityRows = (localStorageKey) => {
  const unparsedDraftAvailabilityRows = localStorage.getItem(localStorageKey);
  const draftAvailabilityRows = JSON.parse(unparsedDraftAvailabilityRows);

  if (!draftAvailabilityRows || !draftAvailabilityRows.length) return undefined;

  const draftAvailabilityHasValues = draftAvailabilityRows.find(
    ({ garageId, dates }) => garageId || dates.length
  );
  return draftAvailabilityHasValues ? draftAvailabilityRows : undefined;
};

export const getGarageAvailabilityToPrefill = (localStorageKey, invitations) => {
  const draftAvailabilityRows = getDraftAvailabilityRows(localStorageKey);
  if (draftAvailabilityRows && draftAvailabilityRows.length) return draftAvailabilityRows;

  const invitationsInReviewAvailability = getAvailabilityFromExistingProposedChanges(invitations);
  if (invitationsInReviewAvailability.length) return invitationsInReviewAvailability;

  return [newGarageRow()];
};
